module.exports = __webpack_public_path__ + "images/emoji/black_nib.3f7fd8a3c766f6d25873.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/black_nib.png
// module id = hPXd
// module chunks = 13